import React from 'react';
import TooltipModal, { TooltipContent, TooltipHeader } from './index';

export default function LinkToPageTooltip() {
  return (
    <TooltipModal>
      <TooltipHeader>Link with Fatsoma Page</TooltipHeader>
      <TooltipContent>
        <p>
          Link your existing{' '}
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://business.fatsoma.com/sign-in"
          >
            Fatsoma Page
          </a>{' '}
          with your Tabb venue to share followers across both of them.
        </p>
        <p>
          <b>Please note:</b> This can only be done once, and Pages cannot be
          unlinked.
        </p>
      </TooltipContent>
    </TooltipModal>
  );
}



// WEBPACK FOOTER //
// ./src/components/Utility/TooltipModal/LinkToPageTooltip.jsx